'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.31 11.88v5.933h4.75v.682H7.968a.341.341 0 0 1-.341-.341V11.88h.682Zm2.484-7.716a3.973 3.973 0 0 1 .954 4.097L13.45 9.97l-.484.481-1.856-1.862a.34.34 0 0 1-.074-.369 3.293 3.293 0 0 0-.725-3.573 3.3 3.3 0 0 0-4.663 0 3.276 3.276 0 0 0-.966 2.332c0 .88.343 1.709.966 2.332a3.292 3.292 0 0 0 3.571.724.342.342 0 0 1 .37.075l1.046 1.046h.625a.34.34 0 0 1 .335.278l.13.685.552.034c.166.01.3.138.318.303l.071.646.568.044-.052.68-.85-.065a.341.341 0 0 1-.313-.303l-.07-.642-.531-.032a.341.341 0 0 1-.314-.278l-.126-.668h-.485a.34.34 0 0 1-.24-.1l-.992-.99a3.972 3.972 0 0 1-4.095-.955A3.953 3.953 0 0 1 4 6.978c0-1.063.414-2.062 1.166-2.814a3.984 3.984 0 0 1 5.628 0Zm-.506 4.648 3.161 3.16-.482.483-3.161-3.161.482-.482ZM7 4.674c.73 0 1.325.594 1.325 1.325 0 .73-.595 1.325-1.325 1.325-.731 0-1.326-.594-1.326-1.325 0-.73.595-1.325 1.326-1.325Zm0 .682a.644.644 0 1 0 .001 1.288.644.644 0 0 0-.001-1.288Zm8.963.318v.682h-3.11v-.682h3.11Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.659 5.674a.34.34 0 0 1 .34.341v12.139c0 .1-.042.193-.117.26l-3.211 2.748a.345.345 0 0 1-.223.082h-1.649a.342.342 0 0 1-.34-.34V8.763c0-.1.042-.195.12-.259l3.21-2.749a.34.34 0 0 1 .221-.082Zm-3.552 3.614h-.967v11.274h.967V9.288Zm3.21-2.35L16.79 9.105v11.058l2.529-2.165V6.939Zm-1.604 6.092c.189 0 .341.153.341.341v.227a.341.341 0 0 1-.682 0v-.227c0-.188.153-.341.341-.341Zm1.236-6.673h-.811l-2.63 2.249h.815l2.626-2.25Z",
    fill: "currentColor"
  })));
});
var FwSet0Rooms = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Rooms = FwSet0Rooms;